<template>
  <div class="scene-language">
    <el-tabs v-model="status" @tab-click="handleClick">
      <el-tab-pane label="电话机器人" name="2"></el-tab-pane>
      <el-tab-pane label="文字机器人" name="3"></el-tab-pane>
    </el-tabs>
    <el-form :model="sceneForm" label-position="left" label-width="100px">
      <el-form-item label="欢迎语：">
        <el-input
          v-model="sceneForm.welcome"
          type="textarea"
          placeholder="请输入欢迎语"
        ></el-input>
      </el-form-item>
      <upload-audio
        :audio.sync="sceneForm.welcomeAudio"
        v-if="status == 2"
      ></upload-audio>
      <el-form-item label="结束语：">
        <el-input
          v-model="sceneForm.goodbye"
          type="textarea"
          placeholder="请输入结束语"
        ></el-input>
      </el-form-item>
      <upload-audio
        :audio.sync="sceneForm.goodbyeAudio"
        v-if="status == 2"
      ></upload-audio>
      <el-button type="three" @click="onSubmit">保存</el-button>
    </el-form>
  </div>
</template>

<script>
  import { isSuccess } from '@/utils/index'
  import { getSceneDetail, saveSceneDetail } from '@/api/setBase'
  export default {
    components: {
      'upload-audio': () => import('@/components/uploadAudio/index.vue'),
    },
    data() {
      return {
        status: '2', // 当前类型
        sceneForm: {
          welcome: '',
          welcomeAudio: '',
          goodbye: '',
          goodbyeAudio: '',
        },
      }
    },
    computed: {
      isTell() {
        return this.status == 2
      },
    },
    mounted() {
      this.getObject()
    },
    methods: {
      async getObject() {
        const res = await getSceneDetail(this.status)

        if (res.data[0].scene.length == 0) {
          this.sceneForm = {
            welcome: '',
            goodbye: '',
            welcomeAudio: '',
            goodbyeAudio: '',
          }
          return
        }
        res.data[0].scene.forEach((item) => {
          if (item.text_code == 'welcome') {
            this.sceneForm.welcome = item.text
            this.sceneForm.welcomeAudio =
              item.audio && item.audio.audio ? item.audio.audio : ''
          } else {
            this.sceneForm.goodbye = item.text
            this.sceneForm.goodbyeAudio =
              item.audio && item.audio.audio ? item.audio.audio : ''
          }
        })
      },
      async onSubmit() {
        const res = await saveSceneDetail({
          status: parseInt(this.status),
          scene: [
            {
              audio: this.sceneForm.welcomeAudio,
              text: this.sceneForm.welcome,
              text_code: 'welcome',
            },
            {
              audio: this.sceneForm.goodbyeAudio,
              text: this.sceneForm.goodbye,
              text_code: 'goodbye',
            },
          ],
        })
        if (isSuccess(res.code)) {
          this.$message.success('保存成功')
        }
      },
      handleClick() {
        this.getObject()
      },
    },
  }
</script>

<style lang="scss">
  .scene-language {
    .el-textarea {
      width: 780px;
    }
    .el-tabs__item {
      font-size: 16px;
    }
    .el-tabs__nav-wrap::after {
      height: 0;
    }
    .upload {
      margin-left: 80px;
    }
    .el-form-item__content {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
    .el-button--primary {
      margin-left: 10px;
    }
  }
</style>
